import Toast from '../components/pages/utils/Toast';
import { API } from '../constants/Constants';
import Instance from './interceptor';

export const generateApiKey = async (name) => {
  try {
    const response = await Instance.post(`${API.GENERATE_API_KEY}`, { name });
    if (response) {
      Toast({ message: `${response?.data?.message}`, variant: 'success' });
      return response;
    }
  } catch (error) {
    Toast({
      message: `${error?.response?.data?.errorMessage}`,
      variant: 'error',
    });
  }
};

export const listOfApiKeys = async () => {
  try {
    const response = await Instance.get(`${API.API_KEY_LIST}`);
    if (response) {
      return response?.data;
    }
  } catch (error) {
    Toast({
      message: `${error?.response?.data?.errorMessage}`,
      variant: 'error',
    });
  }
};
export const updateClient = async (payload) => {
  try {
    const response = await Instance.patch(`${API.UPDATE_CLIENT_NAME}`, payload);
    if (response) {
      Toast({ message: `${response?.data?.message}`, variant: 'success' });
      return response;
    }
  } catch (error) {
    Toast({
      message: `${error?.response?.data?.errorMessage}`,
      variant: 'error',
    });
  }
};
export const regenerateSecretKey = async (payload) => {
  try {
    const response = await Instance.patch(
      `${API.REGENERATE_SECRET_KEY}`,
      payload,
    );
    if (response) {
      Toast({ message: `${response?.data?.message}`, variant: 'success' });
      return response;
    }
  } catch (error) {
    Toast({
      message: `${error?.response?.data?.errorMessage}`,
      variant: 'error',
    });
  }
};
export const listOfCredentials = async (userId) => {
  try {
    const response = await Instance.get(`${API.CREDENTIALS_LIST}/${userId}`);
    if (response) {
      return response?.data;
    }
  } catch (error) {
    Toast({
      message: `${error?.response?.data?.errorMessage}`,
      variant: 'error',
    });
  }
};
export const getCredentialsById = async (id) => {
  try {
    const response = await Instance.get(`${API.CREDENTIALS_BY_ID}/${id}`);
    if (response) {
      return response?.data?.credential;
    }
  } catch (error) {
    Toast({
      message: `${error?.response?.data?.errorMessage}`,
      variant: 'error',
    });
  }
};
export const deleteCredential = async (Id) => {
  try {
    const response = await Instance.delete(`${API.DELETE_CREDENTIAL}/${Id}`);
    if (response) {
      Toast({ message: `${response?.data?.message}`, variant: 'success' });
      return response?.data;
    }
  } catch (error) {
    Toast({
      message: `${error?.response?.data?.errorMessage}`,
      variant: 'error',
    });
  }
};

export const getSecretKey = async (apiKey) => {
  try {
    const response = await Instance.get(`${API.GET_SECRET_KEY}`, {
      params: {
        apiKey,
      },
    });
    if (response) {
      return response?.data?.secretKey;
    }
  } catch (error) {
    Toast({
      message: `${error?.response?.data?.errorMessage}`,
      variant: 'error',
    });
  }
};

export const updateIsDownloadStatus = async (status, keyId) => {
  try {
    const response = await Instance.patch(`${API.CHANGE_DOWNLOAD_STATUS}`, {
      status,
      keyId,
    });
    if (response) {
      Toast({ message: `${response?.data?.message}`, variant: 'success' });
      return response?.data;
    }
  } catch (error) {
    Toast({
      message: `${error?.response?.data?.errorMessage}`,
      variant: 'error',
    });
  }
};

export const deleteKeys = async (key) => {
  try {
    const response = await Instance.delete(`${API.DELETE_KEY}`, {
      params: {
        key,
      },
    });
    if (response) {
      Toast({ message: `${response?.data?.message}`, variant: 'success' });
      return response?.data;
    }
  } catch (error) {
    Toast({
      message: `${error?.response?.data?.errorMessage}`,
      variant: 'error',
    });
  }
};
